const ValidateCloneEvent = (values) => {
    const errors = {};
    const event_urlRegExp = /^[a-zA-Z0-9-]+$/;
    //const numRegExp = /^[\p{L}\p{N}\p{P}\p{Zs}]+$/u;
    const emojiRegex = /[\p{So}\p{Cs}]/gu;

    if (!values.event_name) {
        errors.event_name = "Please provide an event name";
    } else if (values.event_name.match(emojiRegex)) {
        errors.event_name = "Emojis are not allowed";
    } else if (values.event_name.length < 2) {
        errors.event_name = "Please enter an event name with more than 1 character";
    }

    if (!values.start_date) {
        errors.start_date = "Please provide Start Date & Time";
    }

    if (!values.start_time) {
        errors.start_time = "Please provide Start Date & Time";
    }

    if (!values.end_date) {
        errors.end_date = "Please provide End Date & Time";
    }

    if (!values.end_time) {
        errors.end_time = "Please provide End Date & Time";
    }

    if (values.start_date && values.end_date) {
        if (values.start_date > values.end_date) {
            errors.start_date = "Start date cannot be greater than end date";
        }
    }

    if (!values.event_url) {
        errors.event_url = "Please provide an event URL";
    } else if (!values.event_url.match(event_urlRegExp)) {
        errors.event_url = "Event URL can only contain alphanumerics and hyphens (no spaces or special characters)";
    }

    return errors;
};

export default ValidateCloneEvent;
